// Settings.js
const Settings = () => {
	return (
		<div>
			<h1 className='text-2xl font-bold'>Settings Page</h1>
			{/* Settings page content */}
		</div>
	);
};

export default Settings;
